export default __webpack_public_path__ + "static/media/general-footer.bcec5341.png";